import Modal from "react-bootstrap/lib/Modal";
import Button from "../button/button";
import CountrySelect from "../country-select";

import "../../assets/stylesheets/core/dropdown/selectdropdown.scss";
import countryMD from "../../assets/stylesheets/core/modal/countryModal.module.scss";

interface CountryProps {
  name: string;
  iso: string;
  id: number;
}
interface CountrySelectorModalProps {
  closeModal: () => void;
  onClickSubmit: () => void;
  setSelectedCountry: () => void;
  open: boolean;
  selectedCountry: CountryProps;
  countries: CountryProps[];
  type: string;
  submitDisabled: Boolean;
}
const CountrySelectorModal = (props: CountrySelectorModalProps) => {
  const {
    open,
    closeModal,
    countries,
    selectedCountry,
    setSelectedCountry,
    onClickSubmit,
    type,
    submitDisabled,
  } = props;

  return (
    <Modal
      show={open}
      onHide={closeModal}
      dialogClassName={`${countryMD.countryModal} modal-dialog-scrollable mx-auto country-modal`}
      animation={false}
    >
      <a
        type="button"
        className={`${countryMD.bsCloseModal} icon-close position-absolute`}
        onClick={closeModal}
      ></a>

      <Modal.Header className={`${countryMD.modalHeader}`}>Select Country</Modal.Header>
      <Modal.Body className={`${countryMD.modalBody} px-0 pt-0 pt-md-3`}>
        <p className={`${countryMD.modalHeadingTitle} mb-0 pb-lg-4 pb-20 text-center text-md-left`}>
          If you change your address to a different country, your bag will be emptied, and the menu
          will change. You’ll also have to pick new items.
        </p>
        <div className="form-field absolute-error">
          <CountrySelect
            countries={countries}
            selectedCountry={selectedCountry}
            setSelectedCountry={setSelectedCountry}
            type={type}
          />
        </div>
      </Modal.Body>
      <Modal.Footer className={`${countryMD.modalFooter} border-0 pt-3`}>
        <Button
          text="Change Country"
          onClick={onClickSubmit}
          customClass="btn btn-primary btn-h-40 w-md-300px text-uppercase fs-12 border-radius-8"
          isDisabled={submitDisabled}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default CountrySelectorModal;
